<script>
import Layout from '@layouts/main'
import { messageStore } from '@utils/message'
import { messageBoxLeave } from '@utils/message-box'
const initData = () => {
  return {
    groupOrdering: 0,
    groupAlias: '',
    title: '',
    categoryId: '',
    times: 1,
    bonusTimes: 0,
    infinity: 1,
    inventory: 100,
    expireDays: 90,
    bonusExpireDays: 0,
    slogan: '',
    description: '',
    notice: '',
    images: [],
    usageRules: [],
    prices: [
      {
        maxTimes: 5,
        priceGroupOrdering: null,
        productIds: [],
      },
    ],
    bonusPrices: [
      {
        maxTimes: 0,
        priceGroupOrdering: null,
        productIds: [],
      },
    ],
    prepaids: [
      {
        sizeId: null,
        basePrice: 0,
        price: 0,
        state: 0,
      },
    ],
  }
}

export default {
  page() {
    return {
      title: `新增${this.$t('prepaid.BASE')}方案`,
      meta: [{ name: 'description', content: 'Add Prepaid' }],
    }
  },
  components: {
    Layout,
    BaseSteps: () => import('@components/BaseSteps'),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    prices: {
      type: Array,
      required: true,
    },
    tagList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeStep: 1,
      stepList: Object.freeze([
        {
          title: '基本資訊',
          description: '請填寫下方欄位',
          component: () => import('./components/Step1Basic'),
        },
        {
          title: '限制設定',
          description: '請選取可抵扣的購買方案',
          component: () => import('./components/Step2Limit'),
        },
        {
          title: '適用設定',
          description: '請填寫下方欄位',
          component: () => import('./components/Step3Available'),
        },
        {
          title: '價格設定',
          description: '請選取可抵扣的購買方案',
          component: () => import('./components/Step4Prices'),
        },
        {
          title: '圖片設定',
          description: '請上傳圖片',
          component: () => import('./components/Step5Image'),
        },
      ]),
      tryingNextStep: false,
      nextStepButtonVisible: false,
      submitData: Object.assign({}, initData()),
    }
  },
  computed: {
    pagination() {
      return this.$route.params.pagination
    },
    filterData() {
      return this.$route.params.filterData
    },
    filterCurrentCategoryPrices() {
      if (!this.submitData.categoryId) {
        return this.prices
      } else {
        return this.prices.filter((item) => {
          return item.petCategoryId === this.submitData.categoryId
        })
      }
    },
  },
  created() {
    // console.log(this.$route.params.data)
    // if (this.$route.params.data.title) {
    //   this.step1Data = this.$route.params.data
    // }
  },
  methods: {
    async onClickNextStep(currentStep) {
      this.tryingNextStep = true
      try {
        switch (currentStep) {
          case 1:
            await this.$refs.step.validate()
            this.activeStep++
            this.tryingNextStep = false
            break
          case 2:
            if (this.$refs.step.$refs) {
              const formKey = Object.keys(this.$refs.step.$refs)
              if (formKey.length) {
                for (const i of formKey) {
                  if (this.$refs.step.$refs[i].length) {
                    await this.$refs.step.$refs[i][0].validate()
                  }
                }
              }
            }
            this.activeStep++
            this.tryingNextStep = false
            break
          case 3:
            if (this.submitData.prices[0].productIds.length === 0) {
              await this.$confirm('請至少選擇一個服務項目，並設定適用店家', '提示', {
                confirmButtonText: '確定',
                showCancelButton: false,
                type: 'warning',
                center: true,
              })
              this.tryingNextStep = false
              return
            } else if (
              this.submitData.bonusPrices.length > 0 &&
              this.submitData.bonusPrices.some(price => price.hasOwnProperty('serviceId')) &&
              this.submitData.bonusPrices[0].productIds.length === 0
            )  {
              console.log('bonus this.submitData:',this.submitData)

              await this.$confirm('請至少選擇一個贈送項目，並設定適用店家', '提示', {
                confirmButtonText: '確定',
                showCancelButton: false,
                type: 'warning',
                center: true,
              })
              this.tryingNextStep = false
              return
            } else {
              if (
                this.submitData.prices.some((item) => {
                  return item.productIds.length === 0
                })
              ) {
                await this.$confirm('有適用項目尚無選擇適用店家', '提示', {
                  confirmButtonText: '確定',
                  showCancelButton: false,
                  type: 'warning',
                  center: true,
                })
                this.tryingNextStep = false
                return
              }
            }

            this.activeStep++
            this.tryingNextStep = false
            break

          case 4:
            await this.$refs.step.validate()
            this.activeStep++
            this.tryingNextStep = false
            break

          case 5:
            this.submitData = {
              ...this.submitData,
              images: this.submitData.images.map((image, index) => {
                return {
                  ...image,
                  default: index === 0 ? 1 : 0,
                }
              }),
            }
            // 檢查包月贈送項目是否存在
            const { bonusPrices } = this.submitData
            if (!bonusPrices[0].serviceId) {
              this.submitData.bonusPrices = []
            }
            // 新增假的包月資料
            // await this.storePrepaidFakeStoreData()
            await this.$store.dispatch('prepaid/storeGroup', this.submitData)
            messageStore('add')
            this.$router.push({ name: 'prepaid', params: { pagination: this.pagination, filterData: this.filterData } })
            break
        }
      } catch (error) {
        this.tryingNextStep = false
      }
    },
    /**
     * @description 打出假的包月資料
     */
    async storePrepaidFakeStoreData() {
      for (let i = 0, len = 20; i < len; i++) {
        this.submitData.title = `fakePrepaid--${i}`
        await this.$store.dispatch('prepaid/storeGroup', this.submitData)
      }
    },
    goBack() {
      this.activeStep--
      // this.step1Data = this.$refs.step.submitData
    },
    async onClickLeave() {
      try {
        await messageBoxLeave(`${this.$t('prepaid.BASE')}方案`)
        this.$router.push({ name: 'prepaid', params: { pagination: this.pagination, filterData: this.filterData } })
      } catch (error) {
      } finally {
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.page">
      <BaseSteps :active="activeStep" :list="stepList" />
      <el-card :class="$style['card-wrapper']" class="isStyleNormal">
        <keep-alive>
          <component :is="stepList[activeStep - 1].component" ref="step" :default-value.sync="submitData" :tagList="tagList" :products="products" :category="category" :prices="filterCurrentCategoryPrices" />
        </keep-alive>
      </el-card>
      <div :class="$style.footer">
        <el-button class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="onClickLeave">離開</el-button>
        <el-button v-if="activeStep !== 1" class="is-round" data-tour-text="若不想新增此活動，請按「離開」跳出。注意：我們將不會保留此步驟填寫的資料。" @click="goBack">上一步</el-button>
        <el-button class="is-round" data-tour-text="若欄位皆已填寫完成，點擊「下一步」儲存此步驟填寫的資料，前往下一步" type="primary" :loading="tryingNextStep" @click="onClickNextStep(activeStep)">{{
          activeStep !== 5 ? '下一步' : '儲存'
        }}</el-button>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
</style>
